import React from "react";
import i18n from "../../../constants/i18n";
import { withLiteObserverAndTheme } from "../../../core/et3-enhanced-render";
import Et3PageTitle from "../../../core/et3-page-title/index";
import Et3Margin from "../../../core/et3-ui/ET3Margin";
import getCoreHistoryStore from "../../../stores/core/core-history-store";
import DevicesForm from "./user-device-form";
import UserDeviceData from "./user-device-data";
import ET3PageDiv from "../../../core/et3-page-div";

const UserDevices = withLiteObserverAndTheme(() => {
  React.useEffect(() => {
    getCoreHistoryStore().setPageName("USER_DEVICES", "USER_DEVICES");
  }, []);

  return (
    <ET3PageDiv
      fDirection="column"
      alignItems="flex-start"
      justifyContent="flex-start"
      style={{}}
    >
      <Et3PageTitle
        title={i18n.get("DEVICES")}
        subTitle={i18n.get("ADVANCED_MODE")}
        withRefresh={false}
        withHelper={false}
        onPress={() => {}}
      />
      <DevicesForm />
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <UserDeviceData />
    </ET3PageDiv>
  );
});
export default UserDevices;
